export { default as Categories } from './Categories';
export { default as Featured } from './Featured';
export { default as MostPopular } from './MostPopular';
export { default as RecentlyAdded } from './RecentlyAdded';
